import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/api.service';

export interface AuditLogDto {
  id: string;
  entityType: string;
  entityId: string;
  action: string;
  userId: string;
  userEmail: string;
  changes?: string; // JSON diff
  timestamp: string;
}

@Injectable({ providedIn: 'root' })
export class AuditLogService {
  constructor(private api: ApiService) {}

  list(params: { page?: number; pageSize?: number; entityType?: string; action?: string; userId?: string; startDate?: string; endDate?: string } = {}): Observable<any> {
    const p = { page: 1, pageSize: 20, ...(params || {}) };
    // Updated to match API_QUICK_REFERENCE.md - plural form 'audit-logs'
    return this.api.get('/admin/audit-logs', p) as Observable<any>;
  }
}
